import { render } from '@wordpress/element';
import ConnectedPageLayout from './components/connected-page-layout';

render(<ConnectedPageLayout />, document.getElementById('omnisend-connected'));
